const SHORT_DATETIME_FORMATTER = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
})

/**
 * Format dashboard timestamps with one shared short date-time shape.
 *
 * Problem: internal dashboards were relying on raw `toLocaleString()` calls,
 * so “last refreshed” and audit timestamps drifted in precision and layout.
 *
 * @param {string|number|Date|null|undefined} value - raw timestamp input
 * @param {string} [fallback='—'] - label to show when the timestamp is missing
 * @returns {string} short localized timestamp label
 */
export function formatDateTimeShort(value, fallback = '—') {
  if (!value) return fallback
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return fallback
  return SHORT_DATETIME_FORMATTER.format(date)
}
